
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_aqz5h_93",
  "scrolling-background": "awsui_scrolling-background_hyvsj_aqz5h_96",
  "sticky-background": "awsui_sticky-background_hyvsj_aqz5h_102",
  "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_aqz5h_110",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_aqz5h_123",
  "has-sticky-background": "awsui_has-sticky-background_hyvsj_aqz5h_133",
  "drawers-container": "awsui_drawers-container_hyvsj_aqz5h_145",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_aqz5h_156",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_aqz5h_180",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_aqz5h_185",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_aqz5h_204",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_aqz5h_214",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_aqz5h_218",
  "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_aqz5h_232",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_aqz5h_218",
  "drawer": "awsui_drawer_hyvsj_aqz5h_145",
  "drawer-content-container": "awsui_drawer-content-container_hyvsj_aqz5h_263",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_aqz5h_272",
  "drawer-content": "awsui_drawer-content_hyvsj_aqz5h_263",
  "drawer-content-hidden": "awsui_drawer-content-hidden_hyvsj_aqz5h_280",
  "drawer-slider": "awsui_drawer-slider_hyvsj_aqz5h_283",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_aqz5h_290",
  "content": "awsui_content_hyvsj_aqz5h_315",
  "layout": "awsui_layout_hyvsj_aqz5h_336",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_aqz5h_419",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_aqz5h_434",
  "content-type-table": "awsui_content-type-table_hyvsj_aqz5h_448",
  "content-type-cards": "awsui_content-type-cards_hyvsj_aqz5h_448",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_aqz5h_454",
  "is-hide-mobile-toolbar": "awsui_is-hide-mobile-toolbar_hyvsj_aqz5h_457",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_aqz5h_489",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_aqz5h_492",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_aqz5h_502",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_aqz5h_505",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_aqz5h_508",
  "has-header": "awsui_has-header_hyvsj_aqz5h_508",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_aqz5h_529",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_aqz5h_529",
  "has-split-panel": "awsui_has-split-panel_hyvsj_aqz5h_572",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_aqz5h_572",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_aqz5h_588",
  "unfocusable": "awsui_unfocusable_hyvsj_aqz5h_593",
  "container": "awsui_container_hyvsj_aqz5h_603",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_aqz5h_629",
  "is-tools-open": "awsui_is-tools-open_hyvsj_aqz5h_632",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_aqz5h_632",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_aqz5h_632",
  "has-active-drawer": "awsui_has-active-drawer_hyvsj_aqz5h_632",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_aqz5h_641",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_aqz5h_658",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_aqz5h_662",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_aqz5h_666",
  "navigation-container": "awsui_navigation-container_hyvsj_aqz5h_675",
  "show-navigation": "awsui_show-navigation_hyvsj_aqz5h_719",
  "animating": "awsui_animating_hyvsj_aqz5h_742",
  "showButtons": "awsui_showButtons_hyvsj_aqz5h_1",
  "navigation": "awsui_navigation_hyvsj_aqz5h_675",
  "openNavigation": "awsui_openNavigation_hyvsj_aqz5h_1",
  "animated-content": "awsui_animated-content_hyvsj_aqz5h_804",
  "hide-navigation": "awsui_hide-navigation_hyvsj_aqz5h_813",
  "notifications": "awsui_notifications_hyvsj_aqz5h_823",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_aqz5h_829",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_aqz5h_846",
  "position-bottom": "awsui_position-bottom_hyvsj_aqz5h_893",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_aqz5h_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_aqz5h_922",
  "position-side": "awsui_position-side_hyvsj_aqz5h_935",
  "tools-container": "awsui_tools-container_hyvsj_aqz5h_954",
  "tools": "awsui_tools_hyvsj_aqz5h_954",
  "openTools": "awsui_openTools_hyvsj_aqz5h_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_aqz5h_1049",
  "hide-tools": "awsui_hide-tools_hyvsj_aqz5h_1059",
  "show-tools": "awsui_show-tools_hyvsj_aqz5h_1071",
  "has-tools-form": "awsui_has-tools-form_hyvsj_aqz5h_1049",
  "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_hyvsj_aqz5h_1132",
  "trigger": "awsui_trigger_hyvsj_aqz5h_1132",
  "selected": "awsui_selected_hyvsj_aqz5h_1201",
  "badge": "awsui_badge_hyvsj_aqz5h_1221",
  "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_aqz5h_1225",
  "dot": "awsui_dot_hyvsj_aqz5h_1234"
};
  